import { render, staticRenderFns } from "./ApartmentSelectItem.vue?vue&type=template&id=2d995026&scoped=true&"
import script from "./ApartmentSelectItem.vue?vue&type=script&lang=js&"
export * from "./ApartmentSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./ApartmentSelectItem.vue?vue&type=style&index=0&id=2d995026&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d995026",
  null
  
)

export default component.exports